import { useState } from 'react'
import { ICarrierResult, ICarrierOption } from '../../CarrierAutosuggest/types'

interface IConvertedDefaultValue {
  id: string
  text: string
  groupIndex: number
}

interface IUseDefaultOptionsProps {
  defaultValue?: ICarrierResult
  convertedDefaultValue?: IConvertedDefaultValue
  carrierOptions?: ICarrierOption[]
}

// This hook is for setting default options in CarrierAutoSuggest Component
const useDefaultOptions = ({
  carrierOptions,
  convertedDefaultValue,
  defaultValue,
}: IUseDefaultOptionsProps) => {
  const [defaultOptions, setDefaultOptions] = useState<IConvertedDefaultValue[] | undefined>(() => {
    // Setting defaultOptions
    let defaultOptions

    // Setting defaultOptions to a array if a default value is passing
    if (
      defaultValue &&
      convertedDefaultValue &&
      (carrierOptions === undefined || carrierOptions.length === 0)
    ) {
      defaultOptions = [convertedDefaultValue]
      // Setting defaultOptions to carrierOption array to make selectable this options
    } else if (carrierOptions) {
      defaultOptions = carrierOptions.map(({ groupIndex, id, name }) => ({
        id,
        text: name || '',
        groupIndex,
      }))
      // Setting defaultOptions to undefined
    } else {
      defaultOptions = undefined
    }

    return defaultOptions
  })

  return { defaultOptions, setDefaultOptions }
}

export default useDefaultOptions
